import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { AlertTypes } from '@/constants/enums';

import AlertListWithSelection from './AlertListWithSelection';
import SkeletonNodeList from '../SkeletonNodeList';

interface AlertsListProps {
  isLoading: boolean;
  alerts: JSX.Element[];
  openAlertId: string;
  setOpenAlertId;
  type?: AlertTypes;
  onChangeTab?: (string) => void;
}

const AlertsList = ({ isLoading, alerts, openAlertId, setOpenAlertId, type, onChangeTab }: AlertsListProps) => {
  const { t } = useTranslation();

  if (isLoading) {
    return <SkeletonNodeList isLoading count={3} itemWidth={300} itemHeight={140} shouldCenterHorizontally />;
  }

  if (alerts.length !== 0) {
    return type === AlertTypes.Archived ? (
      <>
        <div>{alerts}</div>
        <div className="no-more-alerts-label">{t('No more alerts to show')}</div>
      </>
    ) : (
      <AlertListWithSelection alerts={alerts} setOpenAlertId={setOpenAlertId} openAlertId={openAlertId}>
        <div className="no-more-alerts-label">{t('No more alerts to show')}</div>
      </AlertListWithSelection>
    );
  }

  // No alerts case
  if (type === AlertTypes.Active) {
    return (
      <div className="no-alerts-to-show-label">
        <Trans
          i18nKey="noAlertsToShow"
          t={t}
          components={{
            1: <a onClick={() => onChangeTab(AlertTypes.Archived)}>&nbsp;</a>,
          }}
        />
      </div>
    );
  } else if (type === AlertTypes.Archived) {
    return <div className="no-archived-alerts-label">{t('No archived alerts yet.')}</div>;
  } else {
    return <div className="no-alerts-to-show-label">{t('No alerts to show for this severity type.')}</div>;
  }
};

export default AlertsList;
